import { BaseElementDef, BaseElementDefBase, BaseControlDef, BaseControlDefBase, LockAction, isILockableElement } from "./BaseElementDef";
import { FormJson } from "@cs/FormJson";
import { FormDefinitionFormItem } from "./__DefinitionDataInterface";
import { FormSettings } from "@cs-ts/form-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class FormDef extends BaseElementDef<FormSettings, FormDefinitionFormItem, FormJson> {
    declare externalData: Record<string, string[]>;
    declare formId: string | null | undefined;
    declare formName: string;
    declare formVersion: string;
    declare formHash: string;
    declare status: string;
    declare viewTypes: string[]; // TODO?
    declare locks: string[]; // TODO?
    declare can: Record<string, boolean>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormJson, definitionData: FormDefinitionFormItem, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DynamicForm"; // TODO - not hardcoded?
        this.externalData = elementData.externalData;
        this.can = elementData.can;
        this.formId = elementData.formId;
        this.formName = elementData.formName;
        this.formVersion = elementData.formVersion;
        this.formHash = elementData.formHash;
        this.viewTypes = elementData.viewTypes;
        this.status = elementData.status;
        this.dependencies = elementData.dependencies; // TODO Observable
        this.foreachCounts = elementData.foreachCounts; // TODO Observable
    }

    appendExternalData(data: Record<string, string[]>) {
        this.externalData = this.externalData ?? {};
        for (const [k, v] of Object.entries(data ?? {})) {
            this.externalData[k] = v;
        }
    }

    setData(data: FormJson, excludeChildren?: boolean) {
        this.dependencies = data.dependencies; // TODO Observable
        this.foreachCounts = data.foreachCounts; // TODO Observable
        super.setData(data, excludeChildren);
        this.status = data.status;
        this.viewTypes = data.viewTypes;
        this.formId = this.formId || data.formId;
        this.can = data.can;
        this.externalData = data.externalData;
        this.locks = data.locks;
    }

    getData(excludeChildren?: boolean) {
        const result = super.getData(excludeChildren) as FormJson;
        if (result != null) {
            result.formId = this.formId!;
            result.formName = this.formName;
            result.formVersion = this.formVersion;
            result.formHash = this.formHash;
            result.externalData = this.externalData;
            result.locks = this.locks;
            result.can = this.can;
        }
        return result;
    }

    getLockActions(lock: string): LockAction[] {
        const lockEls = this.getElementsByFilter2(isILockableElement).filter(i => i != this);
        const r = lockEls.flatMap(i => i.getLockActions(lock));
        return r;
    }

    markEdited() {
        const controls = this.getElementsByFilter(i => i instanceof BaseControlDef) as BaseControlDefBase[];
        for (const control of controls) {
            control.markEdited();
        }
    }
}
